import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';

import { ManagedIntegrationRuntime } from 'app/model/integrationRuntime/managed.integrationRuntime';
import { irTypesConst } from 'app/integrationruntime/integrationruntime.constants';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { NamedAdapter } from 'shell-models-lib';
import { formatRegionString } from 'app/shared/utils/region.util';
import { AirflowIntegrationRuntime } from 'app/model/integrationRuntime/airflow.integrationRuntime';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AirflowIntegrationRuntime)
})
export class AirflowIntegrationRuntimeAdapter extends NamedAdapter<AirflowIntegrationRuntime, Model.IntegrationRuntimeResource> {

    public model(): IModel {
        return Metamodel.modelFor(ManagedIntegrationRuntime);
    }

    protected _toResource(ir: AirflowIntegrationRuntime): Model.IntegrationRuntimeResource {
        const modelIR = super._toResource(ir) as Model.IntegrationRuntimeResource;

        let modelIRAirflowProperties: Model.IntegrationRuntimeAirflowProperties | undefined;
        if (ir.airflowVersion != null) {
            modelIRAirflowProperties = {
                airflowVersion: ir.airflowVersion,
                airflowWebUrl: ir.airflowWebUrl,
                gitSyncProperties: ir.gitSyncProperties,
                airflowEnvironmentVariables: ir.airflowEnvironmentVariables,
                airflowConfigurationOverrides: ir.airflowConfigurationOverrides,
                environmentVariables: ir.environmentVariables,
                airflowRequirements: ir.airflowRequirements,
                enableAADIntegration: ir.enableAADIntegration,
                enableTriggerers: ir.enableTriggerers,
                userName: ir.userName,
                password: ir.password,
                airflowEntityReferences: ir.airflowEntityReferences,
                packageProviderPath: ir.packageProviderPath,
                encryptedSecrets: ir.encryptedSecrets,
                secrets: ir.secrets,
                migratedToFabric: ir.migratedToFabric
            };
        }

        let modelIRComputeProperties: Model.IntegrationRuntimeComputeProperties | undefined;
        if (ir.computeLocation != null || ir.computeSize != null || ir.extraNodes != null || ir.enableAutoscale != null ||
            ir.autoScaleMinNodes != null || ir.autoScaleMaxNodes != null) {
            modelIRComputeProperties = {
                location: ir.computeLocation,
                computeSize: ir.computeSize,
                extraNodes: ir.extraNodes,
                enableAutoscale: ir.enableAutoscale,
                autoScaleMinNodes: ir.autoScaleMinNodes,
                autoScaleMaxNodes: ir.autoScaleMaxNodes,
                clusterIP: ir.clusterIP
            };
        }

        const modelIRTypeProperties: Model.ManagedIntegrationRuntimeTypeProperties = {
            computeProperties: modelIRComputeProperties,
            airflowProperties: modelIRAirflowProperties
        };

        const modelIRProperties: Model.ManagedIntegrationRuntime = {
            type: irTypesConst.Managed,
            description: modelIR.properties ? modelIR.properties.description : undefined,
            typeProperties: modelIRTypeProperties
        };

        if (ir.airflowVersion != null) {
            modelIRProperties.type = irTypesConst.Airflow;
        }

        modelIR.properties = modelIRProperties;
        return modelIR;
    }

    protected _toModel(modelIRResource: Model.IntegrationRuntimeResource, integrationRuntime?: AirflowIntegrationRuntime): ManagedIntegrationRuntime {
        if (!integrationRuntime) {
            integrationRuntime = new ManagedIntegrationRuntime();
        }

        super._toModel(modelIRResource, integrationRuntime);

        const modelIRResourceProperties: Model.ManagedIntegrationRuntime = modelIRResource.properties as Model.ManagedIntegrationRuntime;

        if (modelIRResourceProperties.typeProperties.computeProperties != null) {
            integrationRuntime.computeLocation = formatRegionString(modelIRResourceProperties.typeProperties.computeProperties.location);
            integrationRuntime.computeSize = modelIRResourceProperties.typeProperties.computeProperties.computeSize;
            integrationRuntime.extraNodes = modelIRResourceProperties.typeProperties.computeProperties.extraNodes;
            integrationRuntime.enableAutoscale = modelIRResourceProperties.typeProperties.computeProperties.enableAutoscale;
            integrationRuntime.autoScaleMinNodes = modelIRResourceProperties.typeProperties.computeProperties.autoScaleMinNodes;
            integrationRuntime.autoScaleMaxNodes = modelIRResourceProperties.typeProperties.computeProperties.autoScaleMaxNodes;
            integrationRuntime.clusterIP = modelIRResourceProperties.typeProperties.computeProperties.clusterIP;
        }

        if (modelIRResourceProperties.typeProperties.airflowProperties != null) {
            integrationRuntime.airflowVersion = modelIRResourceProperties.typeProperties.airflowProperties.airflowVersion;
            integrationRuntime.airflowWebUrl = modelIRResourceProperties.typeProperties.airflowProperties.airflowWebUrl;
            integrationRuntime.gitSyncProperties = modelIRResourceProperties.typeProperties.airflowProperties.gitSyncProperties;
            integrationRuntime.airflowEnvironmentVariables = modelIRResourceProperties.typeProperties.airflowProperties.airflowEnvironmentVariables;
            integrationRuntime.airflowConfigurationOverrides = modelIRResourceProperties.typeProperties.airflowProperties.airflowConfigurationOverrides;
            integrationRuntime.environmentVariables = modelIRResourceProperties.typeProperties.airflowProperties.environmentVariables;
            integrationRuntime.airflowRequirements = modelIRResourceProperties.typeProperties.airflowProperties.airflowRequirements;
            integrationRuntime.enableAADIntegration = modelIRResourceProperties.typeProperties.airflowProperties.enableAADIntegration;
            integrationRuntime.enableTriggerers = modelIRResourceProperties.typeProperties.airflowProperties.enableTriggerers;
            integrationRuntime.userName = modelIRResourceProperties.typeProperties.airflowProperties.userName;
            integrationRuntime.password = modelIRResourceProperties.typeProperties.airflowProperties.password;
            integrationRuntime.airflowEntityReferences = modelIRResourceProperties.typeProperties.airflowProperties.airflowEntityReferences;
            integrationRuntime.packageProviderPath = modelIRResourceProperties.typeProperties.airflowProperties.packageProviderPath;
            integrationRuntime.encryptedSecrets = modelIRResourceProperties.typeProperties.airflowProperties.encryptedSecrets;
            integrationRuntime.secrets = modelIRResourceProperties.typeProperties.airflowProperties.secrets;
            integrationRuntime.migratedToFabric = modelIRResourceProperties.typeProperties.airflowProperties.migratedToFabric;
        }

        return integrationRuntime;
    }
}
